import { CurrencyPayResponse } from '../redux/models/currencyPay';
import PaymentTypes from './PaymentTypes';

const getPaymentMethod = function getPaymentMethod(
  responseData: CurrencyPayResponse[]
): number {
  const paymentMethod = responseData.find(
    response => response.data && response.data.find(r => r && r.payment.method)
  );
  if (paymentMethod) {
    return paymentMethod.data[0].payment.method;
  }
  return PaymentTypes.Unknown;
};
export default getPaymentMethod;
